var _rect, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7139,
    y: 5.42871,
    width: 9.50058,
    height: 9.50058,
    rx: 3.39306,
    fill: "#0088CC",
    stroke: "#0088CC",
    strokeWidth: 2.03584
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_32_2147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1073 17.9834C20.6712 17.9834 18.6963 19.9583 18.6963 22.3944V25.1088C18.6963 27.5449 20.6712 29.5198 23.1073 29.5198H25.8217C28.2578 29.5198 30.2327 27.5449 30.2327 25.1088V22.3944C30.2327 19.9583 28.2578 17.9834 25.8217 17.9834H23.1073Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1073 17.9834C20.6712 17.9834 18.6963 19.9583 18.6963 22.3944V25.1088C18.6963 27.5449 20.6712 29.5198 23.1073 29.5198H25.8217C28.2578 29.5198 30.2327 27.5449 30.2327 25.1088V22.3944C30.2327 19.9583 28.2578 17.9834 25.8217 17.9834H23.1073Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0356 22.3944C19.0356 20.1457 20.8585 18.3227 23.1073 18.3227V17.6441C20.4838 17.6441 18.357 19.7709 18.357 22.3944H19.0356ZM19.0356 25.1088V22.3944H18.357V25.1088H19.0356ZM23.1073 29.1805C20.8585 29.1805 19.0356 27.3576 19.0356 25.1088H18.357C18.357 27.7323 20.4838 29.8591 23.1073 29.8591V29.1805ZM25.8217 29.1805H23.1073V29.8591H25.8217V29.1805ZM29.8934 25.1088C29.8934 27.3576 28.0704 29.1805 25.8217 29.1805V29.8591C28.4452 29.8591 30.572 27.7323 30.572 25.1088H29.8934ZM29.8934 22.3944V25.1088H30.572V22.3944H29.8934ZM25.8217 18.3227C28.0704 18.3227 29.8934 20.1457 29.8934 22.3944H30.572C30.572 19.7709 28.4452 17.6441 25.8217 17.6441V18.3227ZM23.1073 18.3227H25.8217V17.6441H23.1073V18.3227Z",
    fill: "url(#paint0_linear_32_2147)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_32_2147)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_32_2147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53501 17.9834C7.09889 17.9834 5.12402 19.9583 5.12402 22.3944V25.1088C5.12402 27.5449 7.09889 29.5198 9.53501 29.5198H12.2495C14.6856 29.5198 16.6604 27.5449 16.6604 25.1088V22.3944C16.6604 19.9583 14.6856 17.9834 12.2495 17.9834H9.53501Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53501 17.9834C7.09889 17.9834 5.12402 19.9583 5.12402 22.3944V25.1088C5.12402 27.5449 7.09889 29.5198 9.53501 29.5198H12.2495C14.6856 29.5198 16.6604 27.5449 16.6604 25.1088V22.3944C16.6604 19.9583 14.6856 17.9834 12.2495 17.9834H9.53501Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46333 22.3944C5.46333 20.1457 7.28628 18.3227 9.53501 18.3227V17.6441C6.91149 17.6441 4.78472 19.7709 4.78472 22.3944H5.46333ZM5.46333 25.1088V22.3944H4.78472V25.1088H5.46333ZM9.53501 29.1805C7.28628 29.1805 5.46333 27.3576 5.46333 25.1088H4.78472C4.78472 27.7323 6.91149 29.8591 9.53501 29.8591V29.1805ZM12.2495 29.1805H9.53501V29.8591H12.2495V29.1805ZM16.3211 25.1088C16.3211 27.3576 14.4982 29.1805 12.2495 29.1805V29.8591C14.873 29.8591 16.9997 27.7323 16.9997 25.1088H16.3211ZM16.3211 22.3944V25.1088H16.9997V22.3944H16.3211ZM12.2495 18.3227C14.4982 18.3227 16.3211 20.1457 16.3211 22.3944H16.9997C16.9997 19.7709 14.873 17.6441 12.2495 17.6441V18.3227ZM9.53501 18.3227H12.2495V17.6441H9.53501V18.3227Z",
    fill: "url(#paint1_linear_32_2147)",
    fillOpacity: 0.7,
    mask: "url(#path-4-inside-2_32_2147)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_32_2147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53501 4.41113C7.09889 4.41113 5.12402 6.386 5.12402 8.82212V11.5366C5.12402 13.9727 7.09889 15.9475 9.53501 15.9475H12.2495C14.6856 15.9475 16.6604 13.9727 16.6604 11.5366V8.82212C16.6604 6.386 14.6856 4.41113 12.2495 4.41113H9.53501Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53501 4.41113C7.09889 4.41113 5.12402 6.386 5.12402 8.82212V11.5366C5.12402 13.9727 7.09889 15.9475 9.53501 15.9475H12.2495C14.6856 15.9475 16.6604 13.9727 16.6604 11.5366V8.82212C16.6604 6.386 14.6856 4.41113 12.2495 4.41113H9.53501Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46333 8.82212C5.46333 6.57339 7.28628 4.75044 9.53501 4.75044V4.07183C6.91149 4.07183 4.78472 6.1986 4.78472 8.82212H5.46333ZM5.46333 11.5366V8.82212H4.78472V11.5366H5.46333ZM9.53501 15.6082C7.28628 15.6082 5.46333 13.7853 5.46333 11.5366H4.78472C4.78472 14.1601 6.91149 16.2869 9.53501 16.2869V15.6082ZM12.2495 15.6082H9.53501V16.2869H12.2495V15.6082ZM16.3211 11.5366C16.3211 13.7853 14.4982 15.6082 12.2495 15.6082V16.2869C14.873 16.2869 16.9997 14.1601 16.9997 11.5366H16.3211ZM16.3211 8.82212V11.5366H16.9997V8.82212H16.3211ZM12.2495 4.75044C14.4982 4.75044 16.3211 6.57339 16.3211 8.82212H16.9997C16.9997 6.1986 14.873 4.07183 12.2495 4.07183V4.75044ZM9.53501 4.75044H12.2495V4.07183H9.53501V4.75044Z",
    fill: "url(#paint2_linear_32_2147)",
    fillOpacity: 0.7,
    mask: "url(#path-6-inside-3_32_2147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_32_2147",
    x: 14.6963,
    y: 13.9834,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_2147"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_2147",
    result: "effect2_dropShadow_32_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_2147",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_32_2147",
    x: 1.12402,
    y: 13.9834,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_2147"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_2147",
    result: "effect2_dropShadow_32_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_2147",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_32_2147",
    x: 1.12402,
    y: 0.411133,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_2147"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_2147",
    result: "effect2_dropShadow_32_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_2147",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_2147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_2147",
    x1: 18.9847,
    y1: 19.7139,
    x2: 29.0791,
    y2: 28.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_2147",
    x1: 5.41243,
    y1: 19.7139,
    x2: 15.5068,
    y2: 28.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_2147",
    x1: 5.41243,
    y1: 6.1416,
    x2: 15.5068,
    y2: 14.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.4705aeff080224d2785de76a0b2f3d1c.svg";
export { ForwardRef as ReactComponent };